import { logoSeed } from "../lib/format";

export function TokenBadge({ symbol, size = "md" }: { symbol: string; size?: "sm" | "md" | "lg" }) {
  return (
    <span className={`token-badge token-badge--${size} token-badge--seed-${logoSeed(symbol)}`} aria-hidden="true">
      {symbol.slice(0, 2).toUpperCase()}
    </span>
  );
}
